import React, { FunctionComponent, PropsWithChildren } from 'react';

import css from './styles.css';

type SummarizationControlContentProps = object;

export const SummarizationControlContent: FunctionComponent<PropsWithChildren<SummarizationControlContentProps>> = ({
    children,
}) => {
    return <div className={css.content}>{children}</div>;
};
